import { jsx } from "react/jsx-runtime";
import { useState, useMemo, createContext, useContext } from "react";
const SubmitStatusContext = createContext(void 0);
const SubmitStatusProvider = ({
  children
}) => {
  const [submitSuccessMessage, setSubmitSuccessMessage] = useState();
  const [submitFailureCode, setSubmitFailureCode] = useState();
  const [submitFailureMessage, setSubmitFailureMessage] = useState();
  const value = useMemo(
    () => ({
      submitSuccessMessage,
      submitFailureCode,
      submitFailureMessage,
      setSubmitSuccessMessage,
      setSubmitFailureCode,
      setSubmitFailureMessage
    }),
    [submitSuccessMessage, submitFailureCode, submitFailureMessage]
  );
  return /* @__PURE__ */ jsx(SubmitStatusContext.Provider, { value, children });
};
const useSubmitStatus = () => {
  const context = useContext(SubmitStatusContext);
  if (context === void 0) {
    throw new Error(
      "useSubmitStatus must be used within a SubmitStatusProvider"
    );
  }
  return context;
};
export {
  SubmitStatusProvider,
  useSubmitStatus
};
//# sourceMappingURL=submit-status-context.js.map
